module.exports = __webpack_public_path__ + "static/media/electric.954ad12b.png";